import React from 'react'
import { Modal } from 'react-bootstrap'
import clsx from 'clsx'
/**
 * @param {{
 *    className?: string
 *    centered?: boolean
 *    show: boolean
 *    size?: 'sm' | 'lg' | 'xl'
 *    fullSize?: boolean
 * }} props
 * @param {any} ref
 * @returns {React.Component}
 */

const ZariModal = ({ className, onHide, fullSize, ...props }) => {
  return (
    <Modal
      {...props}
      backdrop={true}       // permite cerrar al hacer click fuera
      keyboard={true}       // permite cerrar con Esc
      onHide={onHide}       // ejecuta el cierre
      centered={true}
      className={clsx('zr-form__modal', className, {
        'zr-form__modal fullsize': fullSize
      })}
    />
  )
}

ZariModal.Header = Modal.Header
ZariModal.Title = Modal.Title
ZariModal.Body = Modal.Body
ZariModal.Footer = Modal.Footer

export default ZariModal
